<div class="signed-out eshava-text-center">
  <h1>{{'SignedOutTitle'|translate:'assets'}}</h1>
  <p>{{'SignedOutText'|translate:'assets'}}</p>
  <button
    type="button"
    class="eshava-btn eshava-btn-primary"
    (click)="signIn()">
    {{'SignIn'|translate:'assets'}}
  </button>
</div>
